import React from 'react';
import { ActivityIndicator, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useAppTheme } from '@/providers/theme-provider';

interface LoadingStateProps {
  message?: string;
  fullScreen?: boolean;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading...',
  fullScreen = true
}) => {
  const theme = useAppTheme();
  const content = (
    <View
      className="flex-1 justify-center items-center"
      accessibilityRole="progressbar"
      accessibilityLiveRegion="polite"
      accessibilityLabel={message}
    >
      <ActivityIndicator size="large" color={theme.colors.primary} accessible={false} />
      <Text className="mt-4 text-foreground" accessible={false}>
        {message}
      </Text>
    </View>
  );

  if (fullScreen) {
    return (
      <SafeAreaView className="flex-1">
        {content}
      </SafeAreaView>
    );
  }

  return content;
};

export default LoadingState;
